import convertObjToParams from 'jquery-param';

export default function* api(url, payload, fetchParams) {
  const _uri = window.serverData._uri;

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
  };

  const body = {
    ...payload,
    _method: 'ajax'
  };

  const response = yield fetch(`${_uri}${url}`, {
    method: 'post',
    mode: 'cors',
    headers,
    credentials: 'same-origin',
    cache: 'default',
    body: convertObjToParams(body),
    ...fetchParams
  });

  let data = {};
  const text = yield response.text();
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.warn(`${_uri}${url}`);
    console.error(e.message);
  }

  if (data.success) {
    return {
      ok: true,
      ...data
    };
  }

  return {
    ok: false,
    ...data
  };
}

export function* apiJSON(url, payload, fetchParams) {
  const _uri = window.serverData._uri;

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    api: 'ajax'
  };

  const response = yield fetch(`${_uri}${url}`, {
    method: 'post',
    mode: 'cors',
    headers,
    credentials: 'same-origin',
    cache: 'default',
    body: JSON.stringify(payload),
    ...fetchParams
  });

  let data = {};
  const text = yield response.text();
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.warn(`${_uri}${url}`);
    console.error(e.message);
  }

  if (data.success) {
    return {
      ok: true,
      ...data
    };
  }

  return {
    ok: false,
    ...data
  };
}

export function normalizeData(data, name, listName, byField = 'id', complicatedField = false) {
  return {
    [name]: data.reduce(
      (acc, s) => ({
        ...acc,
        [complicatedField ? `${s[byField[0]]}-${s[byField[1]]}` : s[byField]]: s
      }),
      {}
    ),
    [listName]: data.map(s => (complicatedField ? `${s[byField[0]]}-${s[byField[1]]}` : s[byField]))
  };
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
